import axios from 'axios';
import { EventBus } from '@/eventBus.js';

export default (headers = { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' }) => {
  const token = localStorage.getItem('authToken')
  if (!token) {
    EventBus.$emit('unauthorized');
    return;
  } 
  headers['Authorization'] = `Bearer ${token}`
  return axios.create({
    timeout: 30000,
    headers,
    responseType: 'json',
    baseURL: '/esdemo',
  });
}